import { mountMultirxHero } from './multirxHero.js';

/** Page d’accueil : logo MultiRX en négatif (course 3D visible à travers). */
export function mountAccueilApp(container: HTMLElement): void {
  container.replaceChildren();
  const page = document.createElement('div');
  page.className = 'accueil-page';
  const host = document.createElement('section');
  host.id = 'accueil-multirx-hero';
  host.className = 'multirx-hero';
  host.setAttribute('aria-label', 'MultiRX');
  page.appendChild(host);
  container.appendChild(page);
  mountMultirxHero(host);
}
